export const generativeAiAppGroupIdBrandGuidelinesEvaluation =
  "/:app_group_id/generative_ai/brand_guidelines_evaluation";
